// @generated by protoc-gen-es v1.3.2
// @generated from file copenhunt/v1/copenhunt.proto (package copenhunt.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum copenhunt.v1.GameMode
 */
export const GameMode = proto3.makeEnum(
  "copenhunt.v1.GameMode",
  [
    {no: 0, name: "NORMAL"},
    {no: 1, name: "DISTANCES_ONLY"},
  ],
);

/**
 * @generated from enum copenhunt.v1.GameCondition
 */
export const GameCondition = proto3.makeEnum(
  "copenhunt.v1.GameCondition",
  [
    {no: 0, name: "NOT_STARTED"},
    {no: 1, name: "DAY"},
    {no: 2, name: "NIGHT"},
    {no: 3, name: "FINISHED"},
  ],
);

/**
 * /////////////// Game /////////////////
 *
 * @generated from message copenhunt.v1.Game
 */
export const Game = proto3.makeMessageType(
  "copenhunt.v1.Game",
  () => [
    { no: 1, name: "team_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "condition", kind: "enum", T: proto3.getEnumType(GameCondition) },
    { no: 5, name: "game_duration_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "seconds_to_next_switch", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "is_paused", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "location_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "location_delay_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ping_interval_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "seconds_to_next_ping", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "latest_ping_timestamp", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "events", kind: "message", T: Event, repeated: true },
    { no: 16, name: "mode", kind: "enum", T: proto3.getEnumType(GameMode) },
  ],
);

/**
 * /////////////// Team /////////////////
 *
 * @generated from message copenhunt.v1.Team
 */
export const Team = proto3.makeMessageType(
  "copenhunt.v1.Team",
  () => [
    { no: 1, name: "player_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "is_hunter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "chat_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "unclaimable_objective_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "extra_pings_remaining", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.Player
 */
export const Player = proto3.makeMessageType(
  "copenhunt.v1.Player",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "coordinates", kind: "message", T: Coordinates, repeated: true },
  ],
);

/**
 * @generated from message copenhunt.v1.Location
 */
export const Location = proto3.makeMessageType(
  "copenhunt.v1.Location",
  () => [
    { no: 1, name: "info", kind: "message", T: LocationInfo },
    { no: 2, name: "seen_by_team_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * /////////////// Event /////////////////
 *
 * @generated from message copenhunt.v1.Event
 */
export const Event = proto3.makeMessageType(
  "copenhunt.v1.Event",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(Event_Type) },
  ],
);

/**
 * @generated from enum copenhunt.v1.Event.Type
 */
export const Event_Type = proto3.makeEnum(
  "copenhunt.v1.Event.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED"},
    {no: 1, name: "MESSAGE_FROM_ADMIN"},
    {no: 2, name: "HUNTERS_PINGED"},
  ],
);

/**
 * @generated from message copenhunt.v1.HealthCheckResponse
 */
export const HealthCheckResponse = proto3.makeMessageType(
  "copenhunt.v1.HealthCheckResponse",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.UpdateCoordinatesRequest
 */
export const UpdateCoordinatesRequest = proto3.makeMessageType(
  "copenhunt.v1.UpdateCoordinatesRequest",
  () => [
    { no: 1, name: "_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "lon", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "tst", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.UpdateCoordinatesResponse
 */
export const UpdateCoordinatesResponse = proto3.makeMessageType(
  "copenhunt.v1.UpdateCoordinatesResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.LocationSetRequest
 */
export const LocationSetRequest = proto3.makeMessageType(
  "copenhunt.v1.LocationSetRequest",
  () => [
    { no: 1, name: "info", kind: "message", T: LocationInfo },
  ],
);

/**
 * @generated from message copenhunt.v1.LocationReleaseToTeamRequest
 */
export const LocationReleaseToTeamRequest = proto3.makeMessageType(
  "copenhunt.v1.LocationReleaseToTeamRequest",
  () => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.LocationReleaseToTeamResponse
 */
export const LocationReleaseToTeamResponse = proto3.makeMessageType(
  "copenhunt.v1.LocationReleaseToTeamResponse",
  () => [
    { no: 1, name: "released", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameCreateRequest
 */
export const GameCreateRequest = proto3.makeMessageType(
  "copenhunt.v1.GameCreateRequest",
  () => [
    { no: 1, name: "team_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "game_duration_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "location_delay_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ping_interval_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "num_extra_pings_for_hunters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "mode", kind: "enum", T: proto3.getEnumType(GameMode) },
  ],
);

/**
 * @generated from message copenhunt.v1.GameCreateResponse
 */
export const GameCreateResponse = proto3.makeMessageType(
  "copenhunt.v1.GameCreateResponse",
  [],
);

/**
 * @generated from message copenhunt.v1.GameCountdownRequest
 */
export const GameCountdownRequest = proto3.makeMessageType(
  "copenhunt.v1.GameCountdownRequest",
  () => [
    { no: 1, name: "times_paused", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameAddChatIdsRequest
 */
export const GameAddChatIdsRequest = proto3.makeMessageType(
  "copenhunt.v1.GameAddChatIdsRequest",
  () => [
    { no: 1, name: "team_chat_ids", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message copenhunt.v1.GameTeamChatIdsResponse
 */
export const GameTeamChatIdsResponse = proto3.makeMessageType(
  "copenhunt.v1.GameTeamChatIdsResponse",
  () => [
    { no: 1, name: "team_chat_ids", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message copenhunt.v1.GameOverviewRequest
 */
export const GameOverviewRequest = proto3.makeMessageType(
  "copenhunt.v1.GameOverviewRequest",
  [],
);

/**
 * @generated from message copenhunt.v1.GameOverviewResponse
 */
export const GameOverviewResponse = proto3.makeMessageType(
  "copenhunt.v1.GameOverviewResponse",
  () => [
    { no: 1, name: "player_infos", kind: "message", T: PlayerInfo, repeated: true },
    { no: 2, name: "condition", kind: "enum", T: proto3.getEnumType(GameCondition) },
    { no: 3, name: "team_info_by_id", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TeamInfoResponse} },
    { no: 4, name: "is_paused", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "seconds_to_next_switch", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "locations", kind: "message", T: LocationInfo, repeated: true },
    { no: 7, name: "location_delay_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "round_duration_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "latest_ping_timestamp", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "seconds_to_next_ping", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "ping_interval_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "events", kind: "message", T: Event, repeated: true },
    { no: 13, name: "current_timestamp", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 14, name: "mode", kind: "enum", T: proto3.getEnumType(GameMode) },
  ],
);

/**
 * @generated from message copenhunt.v1.GameSendChatRequest
 */
export const GameSendChatRequest = proto3.makeMessageType(
  "copenhunt.v1.GameSendChatRequest",
  () => [
    { no: 1, name: "chat_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameBroadcastRequest
 */
export const GameBroadcastRequest = proto3.makeMessageType(
  "copenhunt.v1.GameBroadcastRequest",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameDeletePlayerRequest
 */
export const GameDeletePlayerRequest = proto3.makeMessageType(
  "copenhunt.v1.GameDeletePlayerRequest",
  () => [
    { no: 1, name: "player_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameRemoveObjectiveRequest
 */
export const GameRemoveObjectiveRequest = proto3.makeMessageType(
  "copenhunt.v1.GameRemoveObjectiveRequest",
  () => [
    { no: 1, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "can_reclaim", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameDeleteLocationRequest
 */
export const GameDeleteLocationRequest = proto3.makeMessageType(
  "copenhunt.v1.GameDeleteLocationRequest",
  () => [
    { no: 1, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameDeleteTeamRequest
 */
export const GameDeleteTeamRequest = proto3.makeMessageType(
  "copenhunt.v1.GameDeleteTeamRequest",
  () => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The Team will generate these, the Game will collect them
 *
 * @generated from message copenhunt.v1.PlayerInfo
 */
export const PlayerInfo = proto3.makeMessageType(
  "copenhunt.v1.PlayerInfo",
  () => [
    { no: 1, name: "player_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_hunter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "coordinates", kind: "message", T: Coordinates, repeated: true },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayersRequest
 */
export const PlayersRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayersRequest",
  [],
);

/**
 * @generated from message copenhunt.v1.PlayersResponse
 */
export const PlayersResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayersResponse",
  () => [
    { no: 1, name: "players", kind: "message", T: PlayerInfo, repeated: true },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerCreateRequest
 */
export const PlayerCreateRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayerCreateRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerCreateResponse
 */
export const PlayerCreateResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayerCreateResponse",
  [],
);

/**
 * @generated from message copenhunt.v1.PlayerAddCoordinatesRequest
 */
export const PlayerAddCoordinatesRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayerAddCoordinatesRequest",
  () => [
    { no: 1, name: "coordinates", kind: "message", T: Coordinates },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerAddCoordinatesResponse
 */
export const PlayerAddCoordinatesResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayerAddCoordinatesResponse",
  [],
);

/**
 * @generated from message copenhunt.v1.PlayerCurrentCoordinatesRequest
 */
export const PlayerCurrentCoordinatesRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayerCurrentCoordinatesRequest",
  [],
);

/**
 * @generated from message copenhunt.v1.PlayerCurrentCoordinatesResponse
 */
export const PlayerCurrentCoordinatesResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayerCurrentCoordinatesResponse",
  () => [
    { no: 1, name: "coordinates", kind: "message", T: Coordinates, repeated: true },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerNameRequest
 */
export const PlayerNameRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayerNameRequest",
  [],
);

/**
 * @generated from message copenhunt.v1.PlayerNameResponse
 */
export const PlayerNameResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayerNameResponse",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerTeamRequest
 */
export const PlayerTeamRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayerTeamRequest",
  [],
);

/**
 * @generated from message copenhunt.v1.PlayerTeamResponse
 */
export const PlayerTeamResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayerTeamResponse",
  () => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_hunter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerVisibleInfoRequest
 */
export const PlayerVisibleInfoRequest = proto3.makeMessageType(
  "copenhunt.v1.PlayerVisibleInfoRequest",
  () => [
    { no: 1, name: "game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerVisibleInfoResponse
 */
export const PlayerVisibleInfoResponse = proto3.makeMessageType(
  "copenhunt.v1.PlayerVisibleInfoResponse",
  () => [
    { no: 1, name: "visible_players", kind: "message", T: PlayerInfo, repeated: true },
    { no: 2, name: "visible_locations", kind: "message", T: LocationInfo, repeated: true },
    { no: 3, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * This is ultimately returned to the frontend
 *
 * @generated from message copenhunt.v1.PlayerCoordinates
 */
export const PlayerCoordinates = proto3.makeMessageType(
  "copenhunt.v1.PlayerCoordinates",
  () => [
    { no: 1, name: "Coordinates", kind: "message", T: Coordinates },
    { no: 2, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamCreateRequest
 */
export const TeamCreateRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamCreateRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_hunter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "extra_pings_remaining", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamCreateResponse
 */
export const TeamCreateResponse = proto3.makeMessageType(
  "copenhunt.v1.TeamCreateResponse",
  [],
);

/**
 * @generated from message copenhunt.v1.TeamJoinRequest
 */
export const TeamJoinRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamJoinRequest",
  () => [
    { no: 1, name: "player_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamJoinResponse
 */
export const TeamJoinResponse = proto3.makeMessageType(
  "copenhunt.v1.TeamJoinResponse",
  [],
);

/**
 * @generated from message copenhunt.v1.TeamInfoRequest
 */
export const TeamInfoRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamInfoRequest",
  [],
);

/**
 * @generated from message copenhunt.v1.TeamInfoResponse
 */
export const TeamInfoResponse = proto3.makeMessageType(
  "copenhunt.v1.TeamInfoResponse",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_hunter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "chat_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "unclaimable_objective_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "extra_pings_remaining", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamRoleResponse
 */
export const TeamRoleResponse = proto3.makeMessageType(
  "copenhunt.v1.TeamRoleResponse",
  () => [
    { no: 1, name: "is_hunter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamAddChatIdRequest
 */
export const TeamAddChatIdRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamAddChatIdRequest",
  () => [
    { no: 1, name: "chat_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamDeletePlayerRequest
 */
export const TeamDeletePlayerRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamDeletePlayerRequest",
  () => [
    { no: 1, name: "player_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamGrabObjectiveRequest
 */
export const TeamGrabObjectiveRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamGrabObjectiveRequest",
  () => [
    { no: 1, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamCurrentObjectiveResponse
 */
export const TeamCurrentObjectiveResponse = proto3.makeMessageType(
  "copenhunt.v1.TeamCurrentObjectiveResponse",
  () => [
    { no: 1, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamRemoveObjectiveRequest
 */
export const TeamRemoveObjectiveRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamRemoveObjectiveRequest",
  () => [
    { no: 1, name: "objective_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "can_reclaim", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message copenhunt.v1.TeamSetExtraPingsRequest
 */
export const TeamSetExtraPingsRequest = proto3.makeMessageType(
  "copenhunt.v1.TeamSetExtraPingsRequest",
  () => [
    { no: 1, name: "extra_pings_remaining", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.Coordinates
 */
export const Coordinates = proto3.makeMessageType(
  "copenhunt.v1.Coordinates",
  () => [
    { no: 1, name: "latitude", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "longitude", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "timestamp", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message copenhunt.v1.LocationInfo
 */
export const LocationInfo = proto3.makeMessageType(
  "copenhunt.v1.LocationInfo",
  () => [
    { no: 1, name: "geo_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(LocationInfo_Type) },
    { no: 3, name: "game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum copenhunt.v1.LocationInfo.Type
 */
export const LocationInfo_Type = proto3.makeEnum(
  "copenhunt.v1.LocationInfo.Type",
  [
    {no: 0, name: "UNKNOWN"},
    {no: 1, name: "BANK"},
    {no: 2, name: "TREASURE"},
    {no: 3, name: "HUNTING_GROUNDS"},
  ],
);

/**
 * @generated from message copenhunt.v1.PlayerLocationInfo
 */
export const PlayerLocationInfo = proto3.makeMessageType(
  "copenhunt.v1.PlayerLocationInfo",
  () => [
    { no: 1, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message copenhunt.v1.GameUpdateSettingsRequest
 */
export const GameUpdateSettingsRequest = proto3.makeMessageType(
  "copenhunt.v1.GameUpdateSettingsRequest",
  () => [
    { no: 1, name: "mode", kind: "enum", T: proto3.getEnumType(GameMode) },
    { no: 2, name: "ping_interval_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "num_extra_pings_for_hunters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

